<template>
    <div class="p-2 p-lg-4">
        <div class="row">
            <div class="col-auto ps-4 ms-2">
                <h2>{{ $t("titles.transportations") }}</h2>
            </div>
            <div v-if="$store.getters.hasPerm('add_transportation')" class="col-auto ms-auto">
                <router-link :to="{ name: 'AddTransportation' }" class="btn btn-primary text-white ">
                    {{ $t("transportations.addTransportation") }}
                </router-link>
            </div>
        </div>
        <Table endpoint="/transportations" ref="table" class="mt-3">
            <template v-slot:header>
                <div class="row d-none d-lg-flex">
                    <div class="col-lg-2">{{ $t("orders.id") }}</div>
                    <div class="col-lg-2">{{ $t("transportations.date") }}</div>
                    <div class="col-lg-2">{{ $t("transportations.sender") }}</div>
                    <div class="col-lg-2">{{ $t("transportations.subscriber") }}</div>
                    <div class="col-lg-1"></div>
                </div>
            </template>
            <template #row="line">
                <div class="row py-2 align-items-start">
                    <!-- ID -->
                    <div class="col-12 col-lg-2">
                        <small class="text-muted d-lg-none">{{ $t("orders.id") }}</small>
                        <div>{{ line.item.id }}</div>
                    </div>
                    <!-- Date -->
                    <div class="col-12 col-lg-2">
                        <small class="text-muted d-lg-none">{{ $t("transportations.date") }}</small>
                        <div>
                            <span v-if="line.item.date">{{ line.item.date }}</span>
                            <span v-else>-</span>
                        </div>
                    </div>
                    <!-- Recipient -->
                    <div class="col-12 col-lg-2 text-break">
                        <small class="text-muted d-lg-none">{{ $t("transportations.sender") }}</small>
                        <div>
                            <span v-if="line.item.recipient">{{ line.item.recipient.name }}</span>
                            <span v-else>-</span>
                        </div>
                    </div>
                    <!-- Subscriber -->
                    <div class="col-12 col-lg-2 text-break phone-number">
                        <small class="text-muted d-lg-none">{{ $t("transportations.subscriber") }}</small>
                        <div>
                            <span v-if="line.item.subscriber">{{ line.item.subscriber.name }}</span>
                            <span v-else>-</span>
                        </div>
                    </div>
                    <!-- Action -->
                    <div class="col-12 col-lg-1 mt-2 mt-lg-0">
                        <router-link :to="'/transportation/' + line.item.id"
                            class="btn btn-sm btn-primary text-white w-100 w-lg-auto">
                            {{ $t("utils.detail") }}
                        </router-link>
                    </div>
                </div>
            </template>
        </Table>
    </div>
</template>
<script>
import Table from "@/components/Table.vue";

export default {
    components: {
        Table
    },
    data() {
        return {

        }
    },

}
</script>
<style scoped lang="scss"></style>